/**
 * Created by thakuva on 6/4/2017.
 * @module EllipsesControl
 * @extends React.Component
 */

import React from 'react';
import {Ellipse} from '@ey/canvascoreservices';

export default function EllipsesControl(props) {
	return <Ellipse {...props} />;
}
